import React__default from 'react';
import styled, { css } from 'styled-components';
import { isMobileStyleMixin } from '@amzn/storm-ui';
import { N as NumericOptionWrapper } from './NumericOption-BEP7gL-p.js';
import { N as NumericLabel } from './Label/NumericLabel-C43p7PpZ.js';

const Numeric10Label = /*#__PURE__*/styled(NumericLabel).withConfig({
  componentId: "sc-storm-ui-30062554__sc-14wks8c-0"
})(["padding:6px;width:31px;height:31px;box-sizing:border-box;flex:1;", ""], isMobileStyleMixin(css(["width:", "px;height:", "px;font-size:", ";"], 31 - 6 * 2 + 14 * 2, 31 - 6 * 2 + 14 * 1, ({
  theme
}) => theme.button.normal.mobile.fontSize)));
const Numeric10OptionWrapper = /*#__PURE__*/styled(NumericOptionWrapper).withConfig({
  componentId: "sc-storm-ui-30062554__sc-14wks8c-1"
})(["flex-grow:unset;"]);
function NumericOption(optionProps) {
  return /*#__PURE__*/React__default.createElement(Numeric10OptionWrapper, optionProps, props => /*#__PURE__*/React__default.createElement(Numeric10Label, props));
}

export { NumericOption as N };
//# sourceMappingURL=Numeric10Option-BizmqxOy.js.map
